import { render, staticRenderFns } from "./Manufacturing.vue?vue&type=template&id=2cb7232a&"
import script from "./Manufacturing.vue?vue&type=script&lang=js&"
export * from "./Manufacturing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports